import { render, staticRenderFns } from "./journeySubsidy.vue?vue&type=template&id=6b551500&scoped=true&"
import script from "./journeySubsidy.vue?vue&type=script&lang=js&"
export * from "./journeySubsidy.vue?vue&type=script&lang=js&"
import style0 from "./journeySubsidy.vue?vue&type=style&index=0&id=6b551500&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b551500",
  null
  
)

export default component.exports